import React from 'react';
import styled from 'styled-components';

export const CheckBox = ({
  name,
  label,
  onChange,
  id,
  checked,
  disabled = false,
}) => {

  const changeHandler = () => {
    const newValue = !checked;
    onChange(newValue);
  }

  return (
    <CheckBoxWrapper className={`${disabled ? ' disabled' : ''}`}>
      <label htmlFor={id}>
        <input
          name={name}
          checked={checked}
          onChange={() => changeHandler()}
          className={`checkbox-input ${checked ? 'checked' : ''}`}
          disabled={disabled}
          id={id}
          type="checkbox"
        />
        <span className="checkbox"></span>
        <span className="label-text">{label}</span>
      </label>
    </CheckBoxWrapper>
  );
};

const CheckBoxWrapper = styled.div`
  position: relative;

  &:hover {
    .checkbox {
      background-color: rgba(112, 112, 112, 0.1);
    }
  }

  .checkbox-input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    cursor: pointer;
  }

  .checkbox {
    line-height: 20px;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid rgba(112, 112, 112, 0.44);
    margin-top: 2px;
    border-radius: 3px;
    
    &:before {
      content: " ";
      font-family: initial;
      position: absolute;
      top: 0;
      left: 4.5px;
      width: 9px;
      height: 14px;
      border: solid #F17F26;
      border-width: 0 3px 3px 0;
      background-color: rgba(112, 112, 112, 0);
      transform: rotate(40deg);
      display: none;
    }
  }

  .checkbox-input.checked + .checkbox {
    &:before {
      display: inline-block;
    }
  }

  .checkbox-input:focus + .checkbox {
    outline: 1px solid var(--moi-color-orange);
  }

  label {
    cursor: pointer;
    color: #000;
    font-weight: 400;
    font-size: 15px;
    line-height: 1.2;
    text-align: left;
    display: flex;
    min-height: 20px;

    .label-text {
      display: inline-block;
      padding-left: 30px;
      padding-top: 2px;
    }
  }

  &.disabled {
    .checkbox {
      cursor: not-allowed;
      background-color: rgba(112, 112, 112, 0.1);
      ::before {
        border-color: rgba(0, 0, 0, 0.2);
      }
    }
    label {
      cursor: not-allowed;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/forms/check-box.js